import * as get from 'lodash/get';

import { Formatter } from './formatter.interface';

/**
 * Example usage:
 * new MappedValueFormatter({
 * 	'conservative': 'Conservative',
 * 	'moderate_conservative': 'Moderate Conservative',
 * 	'moderate': 'Moderate',
 * 	'moderate_aggressive': 'Moderate Aggressive',
 * 	'aggressive': 'Aggressive'
 * })
 * 
 * For any raw value which is the key, this will update the formattedValue to the value in the map.
 * Use returnNullIfDoesntExist if you want to return null instead of the key
 */
export class MappedValueFormatter implements Formatter {
	constructor(private mapping: object, private returnNullIfDoesntExist: boolean = false) { }

	public format(keyToFind: any): string {
		return get(this.mapping, keyToFind, this.returnNullIfDoesntExist ? null : keyToFind);
	}
}
